import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$keys2 from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _everyInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/every";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context7; _forEachInstanceProperty(_context7 = ownKeys(Object(source), true)).call(_context7, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context8; _forEachInstanceProperty(_context8 = ownKeys(Object(source))).call(_context8, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable max-lines */
import React, { useMemo, useEffect, useCallback, useState } from 'react';
import invariant from 'invariant';
import { TextInput as RexLabsTextInput, TextArea as RexLabsTextArea } from '@rexlabs/text-input';
import { Checkbox as RexLabsCheckbox } from '@rexlabs/checkbox';
import { RadioGroupInput as RexLabsRadioGroup } from '@rexlabs/radio-input';
import { Field as RexLabsField } from '@rexlabs/form';
import { createSingleValidationRule } from '@rexlabs/validator';
import RexLabsDateInput from '../inputs/date';
import RexLabsTimeInput from '../inputs/time';
import RexLabsSelect from '../inputs/select';
import { FormRendererTabContent } from './tab-content';
import { isFunction, isEmpty, isString, isArray, reduce, uniq, map, memoize } from 'lodash';

function mergeTags(target, context) {
  return isString(target) ? reduce(context, function (acc, val, key) {
    return acc.replace("{{ ".concat(key, " }}"), val);
  }, target) : target;
}

var memoizedCreateSingleValidationRule = memoize(createSingleValidationRule, function (name, rules) {
  var cacheString = name;

  if (isArray(rules)) {
    var _context;

    cacheString = _concatInstanceProperty(_context = "".concat(cacheString, "|")).call(_context, rules.join('|'));
  } else if (isString(rules)) {
    var _context2;

    cacheString = _concatInstanceProperty(_context2 = "".concat(cacheString, "|")).call(_context2, rules);
  }

  return cacheString;
});
export function FormRendererInner(_ref) {
  var _schema$definition, _schema$definition2, _schema$definition3, _schema$definition4, _schema$definition5, _Object$keys;

  var schema = _ref.schema,
      context = _ref.context,
      form = _ref.form,
      initialValues = _ref.initialValues,
      children = _ref.children,
      render = _ref.render,
      Heading = _ref.Heading,
      _ref$customInputs = _ref.customInputs,
      customInputs = _ref$customInputs === void 0 ? {} : _ref$customInputs,
      _ref$TextInput = _ref.TextInput,
      TextInput = _ref$TextInput === void 0 ? RexLabsTextInput : _ref$TextInput,
      _ref$TextAreaInput = _ref.TextAreaInput,
      TextAreaInput = _ref$TextAreaInput === void 0 ? RexLabsTextArea : _ref$TextAreaInput,
      _ref$RadioGroupInput = _ref.RadioGroupInput,
      RadioGroupInput = _ref$RadioGroupInput === void 0 ? RexLabsRadioGroup : _ref$RadioGroupInput,
      _ref$CheckboxInput = _ref.CheckboxInput,
      CheckboxInput = _ref$CheckboxInput === void 0 ? RexLabsCheckbox : _ref$CheckboxInput,
      _ref$SelectInput = _ref.SelectInput,
      SelectInput = _ref$SelectInput === void 0 ? RexLabsSelect : _ref$SelectInput,
      _ref$MultiSelectInput = _ref.MultiSelectInput,
      MultiSelectInput = _ref$MultiSelectInput === void 0 ? RexLabsSelect : _ref$MultiSelectInput,
      _ref$DateInput = _ref.DateInput,
      DateInput = _ref$DateInput === void 0 ? RexLabsDateInput : _ref$DateInput,
      DateTimeInput = _ref.DateTimeInput,
      _ref$TimeInput = _ref.TimeInput,
      TimeInput = _ref$TimeInput === void 0 ? RexLabsTimeInput : _ref$TimeInput,
      _ref$HiddenInput = _ref.HiddenInput,
      HiddenInput = _ref$HiddenInput === void 0 ? function (props) {
    return /*#__PURE__*/React.createElement("input", _extends({
      type: "hidden"
    }, props));
  } : _ref$HiddenInput,
      _ref$Field = _ref.Field,
      Field = _ref$Field === void 0 ? RexLabsField : _ref$Field;

  var values = _valuesInstanceProperty(form),
      errors = form.errors,
      submitCount = form.submitCount;

  invariant(_parseInt(schema === null || schema === void 0 ? void 0 : (_schema$definition = schema.definition) === null || _schema$definition === void 0 ? void 0 : _schema$definition.schema) === 2, 'Must use Schema version 2!');
  var description = schema === null || schema === void 0 ? void 0 : (_schema$definition2 = schema.definition) === null || _schema$definition2 === void 0 ? void 0 : _schema$definition2.description;
  var pages = schema === null || schema === void 0 ? void 0 : (_schema$definition3 = schema.definition) === null || _schema$definition3 === void 0 ? void 0 : _schema$definition3.pages;
  var groups = schema === null || schema === void 0 ? void 0 : (_schema$definition4 = schema.definition) === null || _schema$definition4 === void 0 ? void 0 : _schema$definition4.groups;
  var fields = schema === null || schema === void 0 ? void 0 : (_schema$definition5 = schema.definition) === null || _schema$definition5 === void 0 ? void 0 : _schema$definition5.fields; // Wrap the field to control whether it's mounted or not
  // and have it within the FormRenderer class so that
  // we can access the custom Field from props

  var FieldWrapper = useMemo(function () {
    return function (_ref2) {
      var _ref2$hidden = _ref2.hidden,
          hidden = _ref2$hidden === void 0 ? false : _ref2$hidden,
          rest = _objectWithoutProperties(_ref2, ["hidden"]);

      return !hidden ? /*#__PURE__*/React.createElement(Field, rest) : null;
    };
  }, []);

  function getShouldRender(field) {
    if (_Array$isArray(field.conditions)) {
      var _context3;

      return _everyInstanceProperty(_context3 = field.conditions).call(_context3, function (condition) {
        var name = condition.name,
            operator = condition.operator,
            value = condition.value;
        var leftVal = values[name];
        var isNot = operator.substr(0, 4) === 'not_';
        var comparator = isNot ? _sliceInstanceProperty(operator).call(operator, 4, operator.length) : operator;

        if (/\{\{.*\}\}/.test(name)) {
          leftVal = context[name.replace('{{ ', '').replace(' }}', '')];
        }

        var result;

        switch (comparator) {
          case 'equals':
            {
              result = leftVal === value;
              break;
            }

          case 'greater_than':
            {
              result = leftVal > value;
              break;
            }

          case 'less_than':
            {
              result = leftVal < value;
              break;
            }

          case 'in_array':
            {
              result = _includesInstanceProperty(value).call(value, leftVal);
              break;
            }

          case 'checked':
            {
              result = leftVal === true;
              break;
            }

          case 'empty':
            {
              result = isEmpty(leftVal);
              break;
            }

          default:
            {
              result = false;
            }
        }

        return isNot ? !result : result;
      });
    }

    return true;
  }

  function getFieldProps(field) {
    var _fieldProps$inputProp;

    var name = field.name,
        _field$label = field.label,
        label = _field$label === void 0 ? '' : _field$label,
        _field$description = field.description,
        description = _field$description === void 0 ? '' : _field$description,
        type = field.type,
        customType = field.custom_type,
        prefill = field.prefill,
        validation = field.validation,
        placeholder = field.placeholder,
        options = field.data,
        fieldProps = field.fieldProps;

    var sharedProps = _objectSpread(_objectSpread({}, fieldProps), {}, {
      name: name,
      hidden: !getShouldRender(field),
      label: mergeTags(label, context),
      description: mergeTags(description, context),
      initialValue: !initialValues ? mergeTags(prefill, context) : undefined,
      validate: validation ? memoizedCreateSingleValidationRule(name, validation) : undefined,
      inputProps: _objectSpread({
        placeholder: mergeTags(placeholder, context)
      }, (_fieldProps$inputProp = fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.inputProps) !== null && _fieldProps$inputProp !== void 0 ? _fieldProps$inputProp : {})
    });

    switch (type) {
      case 'text':
        {
          return _objectSpread(_objectSpread({}, sharedProps), {}, {
            Input: TextInput
          });
        }

      case 'textarea':
        {
          return _objectSpread(_objectSpread({}, sharedProps), {}, {
            Input: TextAreaInput
          });
        }

      case 'radio-group':
        {
          return _objectSpread(_objectSpread({}, sharedProps), {}, {
            sendImmediate: true,
            Input: RadioGroupInput,
            inputProps: _objectSpread({
              options: options
            }, sharedProps.inputProps)
          });
        }

      case 'checkbox':
        {
          return _objectSpread(_objectSpread({}, sharedProps), {}, {
            sendImmediate: true,
            isInlineLabel: true,
            Input: CheckboxInput
          });
        }

      case 'select':
        {
          return _objectSpread(_objectSpread({}, sharedProps), {}, {
            sendImmediate: true,
            Input: SelectInput,
            inputProps: _objectSpread({
              items: options
            }, sharedProps.inputProps)
          });
        }

      case 'multi-select':
        {
          return _objectSpread(_objectSpread({}, sharedProps), {}, {
            sendImmediate: true,
            Input: MultiSelectInput,
            inputProps: _objectSpread({
              items: options,
              multi: true
            }, sharedProps.inputProps)
          });
        }

      case 'date':
        {
          return _objectSpread(_objectSpread({}, sharedProps), {}, {
            sendImmediate: true,
            Input: DateInput
          });
        }

      case 'datetime':
        {
          if (!DateTimeInput) {
            throw new Error('The DateTimeInput prop is required when trying to render a DateTime field');
          }

          return _objectSpread(_objectSpread({}, sharedProps), {}, {
            sendImmediate: true,
            Input: DateTimeInput
          });
        }

      case 'time':
        {
          return _objectSpread(_objectSpread({}, sharedProps), {}, {
            sendImmediate: true,
            Input: TimeInput
          });
        }

      case 'hidden':
        {
          return _objectSpread(_objectSpread({}, sharedProps), {}, {
            hidden: true,
            label: null,
            sendImmediate: true,
            Input: HiddenInput
          });
        }

      case 'custom':
        {
          return _objectSpread(_objectSpread({}, sharedProps), {}, {
            sendImmediate: true,
            Input: customInputs[customType]
          });
        }

      default:
        {
          return _objectSpread(_objectSpread({}, sharedProps), {}, {
            Input: TextInput
          });
        }
    }
  } // TODO: type properly


  var normalizedFields = _reduceInstanceProperty(fields).call(fields, function (acc, field) {
    var _pages$find, _groups$find;

    var _field$conditions = field.conditions,
        fieldConditions = _field$conditions === void 0 ? [] : _field$conditions;
    var page = (_pages$find = _findInstanceProperty(pages).call(pages, function (page) {
      return page.name === field.page;
    })) !== null && _pages$find !== void 0 ? _pages$find : {
      name: undefined,
      conditions: []
    };
    var group = (_groups$find = _findInstanceProperty(groups).call(groups, function (group) {
      return group.name === field.group;
    })) !== null && _groups$find !== void 0 ? _groups$find : {
      name: undefined,
      conditions: []
    };
    var pageName = page.name,
        _page$conditions = page.conditions,
        pageConditions = _page$conditions === void 0 ? [] : _page$conditions;
    var _group$name = group.name,
        groupName = _group$name === void 0 ? 'no_group' : _group$name,
        _group$conditions = group.conditions,
        groupConditions = _group$conditions === void 0 ? [] : _group$conditions;

    if (pageName && groupName) {
      var _context4, _context5;

      if (!acc[pageName]) {
        acc[pageName] = {};
      }

      if (!acc[pageName][groupName]) {
        acc[pageName][groupName] = [];
      }

      acc[pageName][groupName].push({
        key: _concatInstanceProperty(_context4 = "".concat(field.name, "_")).call(_context4, schema === null || schema === void 0 ? void 0 : schema.id, "_field"),
        field: _objectSpread(_objectSpread({}, field), {}, {
          conditions: _concatInstanceProperty(_context5 = []).call(_context5, _toConsumableArray(pageConditions), _toConsumableArray(groupConditions), _toConsumableArray(fieldConditions))
        }),
        fieldProps: getFieldProps(field),
        Field: FieldWrapper
      });
    }

    return acc;
  }, {});

  var _useState = useState((_Object$keys = _Object$keys2(normalizedFields)) === null || _Object$keys === void 0 ? void 0 : _Object$keys[0]),
      _useState2 = _slicedToArray(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  var _useState3 = useState(submitCount),
      _useState4 = _slicedToArray(_useState3, 2),
      oldSubmitCount = _useState4[0],
      setOldSubmitCount = _useState4[1];

  var handleTabChange = useCallback(function (tab) {
    setActiveTab(tab.name);
  }, []);
  var items = useMemo(function () {
    return map(normalizedFields, function (fieldGroups, page) {
      var _pages$find2;

      var pageLabel = (_pages$find2 = _findInstanceProperty(pages).call(pages, function (p) {
        return p.name === page;
      })) === null || _pages$find2 === void 0 ? void 0 : _pages$find2.label;
      return {
        name: page,
        label: pageLabel,
        tabProps: {
          groups: groups,
          fieldGroups: fieldGroups,
          Heading: Heading
        },
        Tab: FormRendererTabContent
      };
    });
  }, [Heading, groups, normalizedFields, pages]);
  useEffect(function () {
    var hasErrors = _Object$keys2(errors).length > 0;

    if (hasErrors) {
      var _context6;

      var errorFields = _Object$keys2(errors);

      var errorTabs = uniq(_filterInstanceProperty(_context6 = map(fields, function (_ref3) {
        var name = _ref3.name,
            page = _ref3.page;

        if (_includesInstanceProperty(errorFields).call(errorFields, name)) {
          return page;
        }
      })).call(_context6, Boolean));

      if (submitCount !== oldSubmitCount && errorTabs[0]) {
        setActiveTab(errorTabs[0]);
        setOldSubmitCount(submitCount);
      }
    } // We don't run this effect when submitCount changes
    // because the errors don't change at the same time
    // that submitCount does
    // We also don't want to run this effect when oldSubmitCount
    // changes beacuse then we can run into an infinite loop

  }, [errors, normalizedFields]);
  var defaultDescriptionViewProps = {
    html: description
  };
  var tabProps = {
    items: items,
    activeTab: activeTab,
    alwaysRenderAll: true,
    setActiveTab: setActiveTab,
    onChange: handleTabChange
  };
  var props = {
    schema: schema,
    form: form,
    fields: fields,
    tabProps: tabProps,
    normalizedFields: normalizedFields,
    pages: pages,
    groups: groups,
    defaultDescriptionViewProps: defaultDescriptionViewProps
  };

  if (isFunction(children)) {
    return children(props);
  }

  if (isFunction(render)) {
    return render(props);
  } // TODO: rethink what we want as fallback


  return null;
}